import Loadable, { NullLoader } from '@comeon/loadable';

// Make all the containers loadable under single chunk.

const SportsbookSportPageContainer = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "sportsbook-sport-page" */
			'./sportsbook-sport-page-container'
		),
	loading: NullLoader
});

const SportsbookSportUpcomingContainer = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "sportsbook-sport-page" */
			'./sportsbook-sport-upcoming-container'
		),
	loading: NullLoader
});

const SportsbookSportLiveContainer = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "sportsbook-sport-page" */
			'./sportsbook-sport-live-container'
		),
	loading: NullLoader
});

const SportsbookSportOutrightsContainer = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "sportsbook-sport-page" */
			'./sportsbook-sport-outrights-container'
		),
	loading: NullLoader
});

const SportsbookSportAllLeaguesContainer = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "sportsbook-sport-page" */
			'./all-leagues/sportsbook-sport-all-leagues-container'
		),
	loading: NullLoader
});

const SportsbookSportEventsContainer = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "sportsbook-sport-page" */
			'./sportsbook-sport-events-container'
		),
	loading: NullLoader
});

export {
	SportsbookSportPageContainer,
	SportsbookSportUpcomingContainer,
	SportsbookSportLiveContainer,
	SportsbookSportOutrightsContainer,
	SportsbookSportAllLeaguesContainer,
	SportsbookSportEventsContainer
};
